class Ordenacao {
    constructor(
        {
            currentPage= null,
            perPage= null,
            sortBy= null,
            sortDesc= null
        } = {}
    ) 
    {
        this.currentPage = currentPage;
        this.perPage = perPage;
        this.sortBy = sortBy;
        this.sortDesc = sortDesc;
    }
}

export default Ordenacao;